const types = {
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',

  LOGOUT_REQUEST: 'LOGOUT_REQUEST',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGOUT_FAILURE: 'LOGOUT_FAILURE',

  REGLOGIN_REQUEST: 'REGLOGIN_REQUEST',
  REGLOGIN_FAILURE: 'REGLOGIN_FAILURE',
  REGLOGIN_SUCCESS: 'REGLOGIN_SUCCESS',

  FORGET_REQUEST: 'FORGET_REQUEST',
  FORGET_FAILURE: 'FORGET_FAILURE',
  FORGET_SUCCESS: 'FORGET_SUCCESS',

  COMMIT_REQUEST: 'COMMIT_REQUEST',
  COMMIT_SUCCESS: 'COMMIT_SUCCESS',
  COMMIT_FAILURE: 'COMMIT_FAILURE',
  COMMIT_INIT: 'COMMIT_INIT',

  COMMON_REQUEST: 'COMMON_REQUEST',
  COMMON_SUCCESS: 'COMMON_SUCCESS',
  COMMON_FAILURE: 'COMMON_FAILURE',
  COMMON_INIT: 'COMMON_INIT',

  FETCH_DETAIL_REQUEST: 'FETCH_DETAIL_REQUEST',
  FETCH_DETAIL_SUCCESS: 'FETCH_DETAIL_SUCCESS',
  FETCH_DETAIL_FAILURE: 'FETCH_DETAIL_FAILURE',
  FETCH_DETAIL_INIT: 'FETCH_DETAIL_INIT',

  FETCH_RECORD_REQUEST: 'FETCH_RECORD_REQUEST',
  FETCH_RECORD_SUCCESS: 'FETCH_RECORD_SUCCESS',
  FETCH_RECORD_FAILURE: 'FETCH_RECORD_FAILURE',
  FETCH_RECORD_INIT: 'FETCH_RECORD_INIT',
  
  SHARE_STATUS: 'SHARE_STATUS',
  SAVE_PARAMS: 'SAVE_PARAMS'
}

export default types
